<template>
    <section class="feed_packs mt-16 mb-10">
    <v-container>
     <h2 class="text-center text-capitalize mb-6">{{$t('aboutUs.userFeedpacks')}}</h2>
        <v-container
        v-if="loading">
            <v-row>
            <v-col
            :cols="12"
            :sm="6"
            :md="4"
            >
            <v-skeleton-loader
             
              class="mx-auto white d-block"
              max-height="400"
              type="image"
            ></v-skeleton-loader>
            </v-col>
            <v-col
            :cols="12"
            :sm="6"
            :md="4"
            >
            <v-skeleton-loader
              class="mx-auto white d-none d-sm-block d-md-block"
              max-height="400"
              type="image"
            ></v-skeleton-loader>
            </v-col>
            <v-col
            :cols="12"
            :sm="6"
            :md="4"
            >
            <v-skeleton-loader
              class="mx-auto white  d-none d-sm-none d-md-block"
              max-height="400"
              type="image"
            ></v-skeleton-loader>
            </v-col>
            </v-row>
        </v-container>
         <Carousel
         v-show="!loading"
         :autoplay='true'
         :autoplayHoverPause='true'
         :paginationEnabled='false'
         :scrollPerPage='false'
         :autoplayTimeout="12000"
         :loop='true'
         :autoplayDirection='$vuetify.rtl? "backward":"forward"'
         :perPageCustom='[[0,1],[768,2],[968,3]]'
        >
         <Slide v-for="(feedpack, index) in userFedpacks" :key="index" 
          class="d-flex justify-center"
          >
           <v-card
          max-width="400"
          class="mx-auto ml-2 mr-2 px-4 pt-6"
          :outlined="true"
    >
     <div class="d-flex align-center">
      <img :src="feedpack.img"
       :style="{maxWidth:'120px',Maxheight:'120px'}"
       alt="" srcset=""
       >
       
      <v-card-title  class=" font-weight-bold ms-4" v-text="feedpack[lang].user"></v-card-title>
      </div>
      <v-card-text class="text--primary">
        <div  v-text="feedpack[lang].feedBack"></div>
      </v-card-text>
    </v-card>
         </Slide>
        </Carousel>
        </v-container>
    </section>
</template>

<script>
import {Carousel,Slide} from 'vue-carousel';
import firebase from '@/firebase/index'
import {lang} from '@/mixins/index'

export default {
    name:'feed_packs',
    data() {
        return {
            loading:false,
            userFedpacks:[]
            /*[
                {
                     img:'man1.png',
                     name:'fatime azzahra',
                     feedpack:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est iste tempore voluptate sequi incidunt, repellat provident repudiandae'
                },
                {
                     img:'man2.png',
                     name:'mark adam',
                     feedpack:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est iste tempore voluptate sequi incidunt, repellat provident repudiandae'
                },
                {
                     img:'man3.png',
                     name:'walid oughris',
                     feedpack:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est iste tempore voluptate sequi incidunt, repellat provident repudiandae'
                }
            ]*/
        }
    },
    mixins:[lang],
    methods:{
        getUserFeedBacks(){
            this.loading=true;
             const storage = firebase.storage();
          firebase.firestore().collection('userFeedBacks').get()
          .then((snapshot)=>{
            this.numItems=snapshot.docs.length;
         snapshot.forEach(doc=>{
          storage.ref(doc.data().img).getDownloadURL()
            .then((url) => {
             this.userFedpacks.push({
                 img:url,
                 ar:{
                   user:doc.data().ar.name,
                   feedBack:doc.data().ar.feedBack,
                 },
                 fr:{
                     user:doc.data().fr.name,
                   feedBack:doc.data().fr.feedBack,
                 },
                 en:{
                     user:doc.data().en.name,
                   feedBack:doc.data().en.feedBack,
                 },
               });
               this.loading=false;
            })
         })
       })
        }
    },
    components:{
        Carousel,Slide
    },
    created(){
        this.getUserFeedBacks();
    }
}
</script>

<style lang="scss" scoped>
    .feed_packs{direction: ltr !important;}
</style>